import React, { useEffect } from 'react';
import M from 'materialize-css';
import backgroundImage from '../../config/logo1.png'
import Loader from '../../components/loader'
import Input from '../../components/input'
import Button from '../../components/button'
import { servelURL } from '../../config';

const RepairStatus = function (props) {
    const [loading, setLoading] = React.useState(false);
    const [disabled, setDisabled] = React.useState(false);
    const [code, setCode] = React.useState('')
    const [codeError, setCodeError] = React.useState('')
    const [data, setData] = React.useState('')

    useEffect(function () {
        mount()
        document.title = 'Repair Status';
        M.AutoInit();
        return function () { };
        // eslint-disable-next-line
    }, []);

    async function mount() {
        try {
            setLoading(true);
            const condition = JSON.stringify({ role: "customer" });
            const select = JSON.stringify({});
            const sort = JSON.stringify({});
            const schema = 'user';
            const joinForeignKeys = true;
            const parameters = `schema=${schema}&condition=${condition}&sort=${sort}&select=${select}&joinForeignKeys=${joinForeignKeys}`;

            let response = await fetch(`${servelURL}/list-all?${parameters}`, {
                method: 'GET',
                mode: 'cors',
            });

            response = await response.json();
            setLoading(false);
            if (response.success) {
                setData(response.message)
                setCode('')
            }
            else console.log(response.message)
        }
        catch (error) {
            setDisabled(true);
            if (error instanceof Error) {
                new M.Toast({ html: error.message });
            } else console.error(error);
        }
    }

    const validate = (event) => {
        try {
            event.preventDefault()
            const errors = []

            if ((code !== undefined) && (code === '')) {
                errors.push('')
                setCodeError('Please fill in this field')
                setDisabled(true)
            } else if ((code !== undefined) && (code.length !== 6)) {
                errors.push('')
                setCodeError('Please provide the correct work order number')
                setDisabled(true)
            }

            if (errors.length === 0) {
                if (data !== '') {
                    const searchResult = data.find(item => item.code === code);
                    if (searchResult) {
                        setCode('')
                        props.history.push({
                            state: { account: searchResult },
                            pathname: "/repair/status"
                        })
                    } else {
                        new M.Toast({ html: 'Invalid Work Order Number' })
                        setDisabled(true)
                        setCode('')
                    }
                }
                else {
                    new M.Toast({ html: 'Invalid Work Order Number' })
                    setDisabled(true)
                }
            } else {
                setLoading(false);
            }
        }
        catch (error) {
            setDisabled(true);
            if (error instanceof Error) {
                new M.Toast({ html: error.message });
            } else console.error(error);
        }
    }

    return (
        <main>
            {loading ? <Loader /> : null}
            <div
                className='background-image'
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    opacity: 0.2,
                    zIndex: -1,
                }}
            >
            </div>
            <div className='row' style={{ marginTop: '2rem' }}>
                <div className='col s12 m8 push-m2'>
                    <h1 className='center red-text'>Repair Status Track</h1>
                    <div className='card hoverable'>
                        <form onSubmit={validate} className='container'>
                            <div className='card-content'>
                                <span className='card-title center'>Follow Up Your Service</span>
                                <div className='row'>
                                    <div className='col s12'>
                                        <Input
                                            type='number'
                                            onChange={(event) => setCode(event.target.value, setCodeError(''), setDisabled(false))}
                                            name='code'
                                            value={code}
                                            label='Work Order Number'
                                        />
                                        <span className='helper-text red-text'>{codeError ? codeError : ""}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='card-action center'>
                                <Button
                                    disabled={disabled ? true : false}
                                    className='btn-small red'
                                    type='search'
                                    icon='search'
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default React.memo(RepairStatus);